import React, {useRef, useState} from "react";
import {Link, Navigate} from 'react-router-dom';
import Box from "@mui/material/Box";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {
    Card,
    Button,
    Divider,
    Grid,
    IconButton,
    InputAdornment,
    Stack,
    Typography
} from '@mui/material';
import InputField from "../../components/InputField";
import Form from "../../components/Form";
import {BASE_URL} from "../../constants";
import AlertBar from "../../components/AlertBar";
import {reportErrors} from "../../helpers";

export default function Register(props) {
    const form = useRef();
    const alert = useRef();
    const firstNameRef = useRef();
    const lastNameRef = useRef();
    const companyRef = useRef();
    const phoneRef = useRef();
    const emailRef = useRef();
    const passwordRef = useRef();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showPassword, setShowPassword] = React.useState(false);
    const [firstName, setFirstName] = useState();
    const [lastName, setLastName] = useState();
    const [company, setCompany] = useState();
    const [phoneNumber, setPhoneNumber] = useState();
    const [emailAddress, setEmailAddress] = useState();
    const [password, setPassword] = useState();
    const [isCreated, setIsCreated] = useState(false);
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const submit = () => {
        let data = {
            firstName,
            lastName,
            phone: phoneNumber,
            email: emailAddress,
            name: company,
            password
        };
        if (!isSubmitting && form.current.validate()) {
            setIsSubmitting(true);
            alert.current.showProgress("")
            window.axios
                .post(`${BASE_URL}auth/create-account`, data)
                .then((response) => {
                    setIsSubmitting(false);
                    alert.current.hide();
                    alert.current.showSuccess("Account Created Successfully")
                    setTimeout(() => {
                        setIsCreated(true);
                    }, 2000);
                }).catch((error) => {
                setIsSubmitting(false);
                reportErrors(alert.current, error);
            });
        }

    }

    return (
        isCreated ? <Navigate to={{pathname: "/"}}/> :
            <Box sx={{minHeight: '100vh'}}>
                <Grid item xs={12} container justifyContent="center" alignItems="center"
                      sx={{minHeight: {xs: 'calc(100vh - 134px)', md: 'calc(100vh - 112px)'}}}>
                    <Card
                        elevation={2}
                        sx={{
                            maxWidth: {xs: 400, lg: 475},
                            margin: {xs: 2.5, md: 3},
                            '& > *': {
                                flexGrow: 1,
                                flexBasis: '50%'
                            }
                        }}
                    >
                        <Box sx={{p: {xs: 2, sm: 3, md: 4, xl: 5}}}>
                            <Grid item>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <Stack direction="row" justifyContent="space-between" alignItems="baseline"
                                               sx={{mb: {xs: -0.5, sm: 0.5}}}>
                                            <Typography variant="h4">Sign up</Typography>
                                            <Typography component={Link} to="/" variant="body1"
                                                        sx={{textDecoration: 'none'}} color="primary">
                                                Already have an account?
                                            </Typography>
                                        </Stack>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <AlertBar ref={alert}/>
                                        <Form ref={form}>
                                            <Grid container spacing={3}>
                                                <Grid item xs={12} md={6}>
                                                    <InputField
                                                        ref={firstNameRef}
                                                        required={true}
                                                        type="text"
                                                        label="First Name"
                                                        onChange={(value) => setFirstName(value)}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <InputField
                                                        ref={lastNameRef}
                                                        required={true}
                                                        type="text"
                                                        label="Last Name"
                                                        onChange={(value) => setLastName(value)}
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <InputField
                                                        ref={companyRef}
                                                        required={true}
                                                        type="text"
                                                        label="Company"
                                                        placeholder="Demo. in"
                                                        onChange={(value) => setCompany(value)}
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <InputField
                                                        ref={phoneRef}
                                                        required={true}
                                                        type="text"
                                                        label="Phone Number"
                                                        placeholder="Phone number"
                                                        onChange={(value) => setPhoneNumber(value)}
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <InputField
                                                        ref={emailRef}
                                                        required={true}
                                                        type="email"
                                                        label="Email Address"
                                                        onChange={(value) => setEmailAddress(value)}
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <InputField
                                                        ref={passwordRef}
                                                        required={true}
                                                        type={showPassword ? 'text' : 'password'}
                                                        label="Enter password"
                                                        onChange={(value) => setPassword(value)}
                                                        endAdornment={
                                                            <InputAdornment position="end">
                                                                <IconButton
                                                                    aria-label="toggle password visibility"
                                                                    onClick={handleClickShowPassword}
                                                                    onMouseDown={handleMouseDownPassword}
                                                                    edge="end"
                                                                    size="large"
                                                                >
                                                                    {showPassword ? <VisibilityOffIcon/> :
                                                                        <RemoveRedEyeIcon/>}
                                                                </IconButton>
                                                            </InputAdornment>
                                                        }
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Typography variant="body2">
                                                        By Signing up, you agree to our &nbsp;
                                                        <Link variant="subtitle2" component={Link} to="#">
                                                            Terms of Service
                                                        </Link>
                                                        &nbsp; and &nbsp;
                                                        <Link variant="subtitle2" component={Link} to="#">
                                                            Privacy Policy
                                                        </Link>
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Button
                                                        disableElevation
                                                        disabled={isSubmitting}
                                                        fullWidth
                                                        size="large"
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={() => submit()}
                                                    >
                                                        Sign up
                                                    </Button>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Divider>
                                                        <Typography variant="caption"> Sign up </Typography>
                                                    </Divider>
                                                </Grid>
                                            </Grid>
                                        </Form>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                    </Card>
                </Grid>
            </Box>
    );
}
